import { render } from "./DashboardSSH.vue?vue&type=template&id=1bf585df&scoped=true"
import script from "./DashboardSSH.vue?vue&type=script&lang=js"
export * from "./DashboardSSH.vue?vue&type=script&lang=js"

import "./DashboardSSH.vue?vue&type=style&index=0&id=1bf585df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf585df"]])

export default __exports__